<template>
  <v-container class="app-max-width">
    <v-alert v-if="timeReached" class="text-center">{{ $t('general.timer.time_reached') }}</v-alert>
    <v-row :class="{'content-covered':timeReached}">
      <v-col cols="12">
        <QuestionContentRenderer :question="question"></QuestionContentRenderer>
      </v-col>
    </v-row>
    <v-row :class="{'content-covered':timeReached}">
      <v-col cols="12">
        <QuestionresponseRenderer :journeyresponse="journeyresponse" @complete="emitComplete($event)" @time-reached="timeReached=true"></QuestionresponseRenderer>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import questionLayoutMixin from "./questionLayoutMixin";
import applicationEventHub from "../../../../events/applicationEventHub";
export default {
  name: "VerticalQuestionLayout",
  mixins:[questionLayoutMixin],
  data(){
    return {
      timeReached : false
    }
  },
  created(){
    applicationEventHub.$on('framework.back',this.back);
    applicationEventHub.$on('framework.next',this.next);
  },
  methods:{

  },
  beforeDestroy(){
    applicationEventHub.$off('framework.back',this.back);
    applicationEventHub.$off('framework.next',this.next);
  }
}
</script>

<style scoped>

</style>